import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { ValidationForm } from "../models/validation-form";
import { Observable } from "rxjs";
import { GeneralField } from "../models/general-field";
import { ValidationFormPost } from "../models/validation-form-post";
import { ValidationFormGet } from "../models/validation-form-get";
import { ValidationFormAnswer } from "../models/validation-form-answer";
import { ValidationFormAnswerPost } from "../models/validation-form-answer-post";
import { ValidationFormSmall } from "../models/validation-form-small";
import { ValidationFormTokenAccess } from "../models/validation-form-token-access";
import { ValidationFormAnswerStateEnum } from "../models/enum/validation-form-answer-state-enum";
import { ExistingUser } from "../models/existing-user";
import { UpdateMotivation } from "../models/update-motivation";

@Injectable({
  providedIn: 'root'
})

export class ValidationFormApiService {
  private apiBaseUrl = `${environment.apiUrl}validationForm`;

constructor(private httpClient: HttpClient) { }

public getValidationFormById(validationFormId: number) {
  return this.httpClient.get<ValidationFormGet>(`${this.apiBaseUrl}/${validationFormId}`);
}
 public postValidationForm(validationForm: ValidationFormPost) {
    return this.httpClient.post(this.apiBaseUrl, validationForm)
 }

   public patchValidationForm(validationForm: ValidationFormPost) {
     return this.httpClient.patch(`${this.apiBaseUrl}/${validationForm.id}`, validationForm);
   }


   public getDefaultGeneralFields(): Observable<GeneralField[]> {
    return this.httpClient.get<GeneralField[]>(`${this.apiBaseUrl}/defaultFields`)
}

public getTaskDetailsByValidationFormId(validationFormId: number): Observable<Task> {
  return this.httpClient.get<Task>(`${this.apiBaseUrl}/taskDetails/${validationFormId}`);
}

public forwardValidationForm(validationFormId: number, userIds: number[], emails: string[], lang: string)  {
  const requestBody = {
    validationFormId,
    userIds,
    emails,
    lang
  };
  return this.httpClient.post(this.apiBaseUrl + '/forward', requestBody, { responseType: 'text' });
}

public validationFormAnswerPost( validationFormAnswer: ValidationFormAnswerPost) {
  return this.httpClient.post(`${this.apiBaseUrl}/send`, validationFormAnswer);
}
public getValidationFormsByProfileId(profileId: number): Observable<ValidationFormSmall[]> {
  return this.httpClient.get<ValidationFormSmall[]>(`${this.apiBaseUrl}/validationFormsByProfileId/${profileId}`);
}

public getValidationFormAnswerByUserId(userId: number, validationFormId: number): Observable<ValidationFormAnswer> {
  const params = new HttpParams().set('validationFormId', validationFormId);
  return this.httpClient.get<ValidationFormAnswer>(`${this.apiBaseUrl}/byUserId/${userId}`, { params });
}
public getValidationFormAnswerByProfileId(profileId: number, validationFormId: number): Observable<ValidationFormAnswer> {
  const params = new HttpParams().set('validationFormId', validationFormId);
  return this.httpClient.get<ValidationFormAnswer>(`${this.apiBaseUrl}/byProfileId/${profileId}`, { params });
}

public getAccessToken(token: string): Observable<ValidationFormTokenAccess> {
  return this.httpClient.get<ValidationFormTokenAccess>(`${this.apiBaseUrl}/accessToken/${token}`);
}

public GetUsersOutsideOfPitten(validationFormId: number): Observable<string[]> {
  return this.httpClient.get<string[]>(`${this.apiBaseUrl}/accessTokenEmails/${validationFormId}`);
}

public getByTaskId(taskId: number): Observable<ValidationFormGet> {
  return this.httpClient.get<ValidationFormGet>(`${this.apiBaseUrl}/byTaskId/${taskId}`);
}

public updateValidationRatingFormField(requestBody: {
  ratingFieldId: number,
  name?: string,
  nameUk?: string
}): Observable<string> {
  return this.httpClient.patch(
    `${this.apiBaseUrl}/rating/${requestBody.ratingFieldId}/edit`,
    {
       ratingFieldId: requestBody.ratingFieldId,
      name: requestBody.name,
      nameUk: requestBody.nameUk
    },
    { responseType: 'text' }
  );
}

public updateValidationGeneralFormField(requestBody: {
  generalFieldId: number,
  name?: string,
  nameUk?: string
}): Observable<string> {
  return this.httpClient.patch(
    `${this.apiBaseUrl}/general/${requestBody.generalFieldId}/edit`,
    {
      generalField: requestBody.generalFieldId,
      name: requestBody.name,
      nameUk: requestBody.nameUk
    },
    { responseType: 'text' }
  );
}
public updateValidationFormAnswerState(validationFormAnswerId: number, state: ValidationFormAnswerStateEnum) {
  const params = new HttpParams().set('state', state);
  return this.httpClient.patch(`${this.apiBaseUrl}/${validationFormAnswerId}/state`, {}, { params, responseType: 'text' as 'text' });
}

public updateValidationFormFieldAnswer(validationFormFieldAnswerId: number, answer: string): Observable<string> {
  const params = new HttpParams().set('answer', answer);
  return this.httpClient.patch(`${this.apiBaseUrl}/${validationFormFieldAnswerId}/answer`, {}, { params, responseType: 'text' as 'text' });
}

public updateValidationFormAnswerMotivation(motivation: string, validationFormAnswerId: number): Observable<UpdateMotivation> {
  const updateMotivation: UpdateMotivation = {
    motivation: motivation,
    validationFormAnswerId: validationFormAnswerId
  };
  return this.httpClient.patch<UpdateMotivation>(
    `${this.apiBaseUrl}/${updateMotivation.validationFormAnswerId}/motivation`,
    updateMotivation
  );
}


public getValidationFormAnswerByChosenProfileId(chosenProfileId: number): Observable<ValidationFormAnswer> {
  return this.httpClient.get<ValidationFormAnswer>(`${this.apiBaseUrl}/byChosenProfileId/${chosenProfileId}`);
}

public uploadAnswerImage(file: File): Observable<string> {
  const formData = new FormData();
  formData.append('File', file);
  return this.httpClient.post(
      `${this.apiBaseUrl}/uploadAnswerImage`,
      formData,
      { responseType: 'text' }
  );
}

public checkExistingUser(email: string): Observable<ExistingUser> {
    const params = new HttpParams().set('email', email);
    return this.httpClient.get<ExistingUser>(`${this.apiBaseUrl}/checkExistingUser`, { params });
}

public updateValidationFormFieldToggleShowCommand(requestBody: {
  fieldId: number,
  validationFormId: number,
  showToConsultant?: boolean,
  showToCustomer?: boolean
}): Observable<string> {
  return this.httpClient.patch(
    `${this.apiBaseUrl}/updateShow/${requestBody.fieldId}`,
    {
      fieldId: requestBody.fieldId,
      validationFormId: requestBody.validationFormId,
      showToConsultant: requestBody.showToConsultant,
      showToCustomer:requestBody.showToCustomer
    },
    { responseType: 'text' }
  );
}

}
